/**
 * @generated SignedSource<<79f9bfcc37cd62f909d1301b9a0ba3ac>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type DragActionsButton$data = {
  readonly issueTypeField?: {
    readonly issueType: {
      readonly avatar: {
        readonly small: string | null | undefined;
      } | null | undefined;
      readonly name?: string;
    } | null | undefined;
  } | null | undefined;
  readonly summary?: string | null | undefined;
  readonly " $fragmentType": "DragActionsButton";
};
export type DragActionsButton$key = {
  readonly " $data"?: DragActionsButton$data;
  readonly " $fragmentSpreads": FragmentRefs<"DragActionsButton">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isReparentingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "DragActionsButton",
  "selections": [
    {
      "condition": "isReparentingEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "summary"
        },
        {
          "concreteType": "JiraIssueTypeField",
          "kind": "LinkedField",
          "name": "issueTypeField",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraIssueType",
              "kind": "LinkedField",
              "name": "issueType",
              "plural": false,
              "selections": [
                {
                  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "name"
                    }
                  ]
                },
                {
                  "concreteType": "JiraAvatar",
                  "kind": "LinkedField",
                  "name": "avatar",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "small"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "393733eb40041d691aec62e761940301";

export default node;
